import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import { Button, Grid } from '@material-ui/core'
import {
  ERROR_COLORS,
  GRAY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'

import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import AccordionTwoHead from 'asterX-UI/Accordion/AccordionTwoHead'
import HeaderBack from '../HeaderBack'
import ClientNeeds from 'components/Mobile/ClientNeeds'
import {
  CS_CALL_CLIENT,
  CS_ISSUANCE_CAR,
  CS_ISSUE,
  CS_ISSUE_MANAGER,
  CS_MEET_CLIENT,
  MISSING
} from 'constants/events'
import HistoryOfSelection from 'components/Mobile/HistoryOfSelection'
import moment from 'moment/moment'
import { useResErrors, useRoutes } from 'hooks'
import { SELECTION_STEP_PATH_LOADED } from 'routes/constants.routes'
import { parseJson } from 'lib/utils'
import { Modal } from 'asterX-UI/Modals'
import CloseTaskComponent from 'components/Mobile/Tasks/CloseTaskComponent'
import CreateTaskComponent from 'components/Mobile/Tasks/CreateTaskComponent'
import CloseRLModal from 'components/Mobile/CloseRLModal'
import useTaskApis from 'hooks/useTaskApis'
import { SalesService } from 'lib/api'
import { ACTIVE, getPrevStepByStatus, MISSED, PAYMENT } from 'constants/deals'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import CommentItem from '../CommentItem'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  infoBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    marginBottom: 12,
    fontSize: 14,
    fontWeight: 400
  },
  title: {
    width: 100,
    color: GRAY_COLORS['400']
  },
  text: {
    color: GRAY_COLORS['700'],
    maxWidth: 250
  },
  time: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    fontFamily: 'Inter',

    '&.expired': {
      color: ERROR_COLORS[500]
    },
    '&.today': {
      color: WARNING_COLORS[500]
    },
    '&.tomorrow': {
      color: SUCCESS_COLORS[500]
    }
  },
  btns: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '96%',
    bottom: 10
  },
  row: {
    display: 'flex',
    gap: 12
  },
  needs: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    gap: 5,
    paddingBottom: 0
  },
  container: {
    height: '76vh',
    overflowY: 'auto'
  },
  errorBtn: {
    color: ERROR_COLORS[700],
    backgroundColor: ERROR_COLORS[100]
  }
}))

const TaskModal = ({ onClose, task, endDate }) => {
  const { goTo } = useRoutes()
  const classes = useStyles()
  const start = moment(task.start, 'YYYY-MM-DD HH:mm')
  const end = moment(task.end, 'YYYY-MM-DD HH:mm')
  const { completeEvent, taskIsLoading } = useTaskApis()
  const { standardCheck } = useResErrors()
  const [open, setOpen] = useState({
    isCloseTaskOpen: false,
    isCloseRlModalOpen: false,
    isCreateTask: false
  })
  const [commentsRSE, setCommentsRSE] = useState(null)
  const [sale, setSale] = useState(null)
  const [loading, setLoading] = useState(false)
  const [comments, setComments] = useState([])

  useEffect(() => {
    getSaleById()
  }, [])

  useEffect(() => {
    getAllComments()
  }, [sale?.globalId])

  const goToSelection = async () => {
    setLoading(true)
    await SalesService.updateSale({
      id: sale?.id,
      saleStatus: { code: ACTIVE }
    }).then(res =>
      standardCheck(res, () => {
        const step = getPrevStepByStatus(
          sale?.saleStatus?.code,
          sale?.saleStatusTrack?.code
        )

        goTo(SELECTION_STEP_PATH_LOADED(task.dealId)[step])
      })
    )
    setLoading(false)
  }
  const onCall = () => {
    const callElement = document.createElement('a')
    let phoneNumber = task.contactPhone1.toStandardPhone()
    if (phoneNumber.startsWith('7')) {
      phoneNumber = `+${phoneNumber}`
    }
    callElement.setAttribute('href', `tel:${phoneNumber}`)

    callElement.click()
  }

  const handleOpen = type => () => {
    setOpen(prevState => ({
      ...prevState,
      [type]: !prevState?.[type]
    }))
  }
  const onSaveCloseTask = async isNew => {
    if (isNew) {
      handleOpen('isCloseTaskOpen')()
      return handleOpen('isCreateTask')()
    }
    onClose()
    handleOpen('isCloseTaskOpen')()
  }
  const onSaveNewTask = () => {
    onClose()
  }
  const onReasonClose = async result => {
    return await completeEvent({
      data: {
        type: MISSING,
        id: task.id,
        result
      },
      onSuccess: async res => {
        setLoading(true)
        await SalesService.updateSale({
          id: task.dealId,
          closedByRop: false,
          clientDeclined: true,
          result,
          saleStatus: { code: MISSED }
        }).then(res =>
          standardCheck(res, () => {
            onClose()
          })
        )
        setLoading(false)
      }
    })
  }
  const getSaleById = async () => {
    setLoading(true)
    await SalesService.getByIdForSelection(task.dealId).then(res =>
      standardCheck(
        res,
        () => {
          setCommentsRSE(parseJson(res.data?.commentsRSE))
          setSale(res.data)
        },
        {
          onFail: () => {
            onClose()
          }
        }
      )
    )
    setLoading(false)
  }

  const getAllComments = async () => {
    await SalesService.getAllComments(sale?.globalId).then(res => {
      if (res.status === 200) {
        setComments(res?.data)
      }
    })
  }

  return (
    <PageContainerMobile
      customHeader={<HeaderBack onClick={onClose}>{task.title}</HeaderBack>}
      style={{
        backgroundColor: '#FAFAFA',
        height: '100%',
        position: 'relative'
      }}
    >
      <LoaderBackdrop oading={taskIsLoading || loading} />
      <div className={classes.container}>
        <div className={classes.info}>
          <div className={classes.infoBlock}>
            <div className={classes.title}>Клиент</div>
            <div className={classes.text}>{task.contactFullname}</div>
          </div>
          <div className={classes.infoBlock}>
            <div className={classes.title}>Телефон</div>
            <div className={classes.text}>{task?.contactPhone1}</div>
          </div>
          <div className={classes.infoBlock}>
            <div className={classes.title}>№ РЛ</div>
            <div className={classes.text}>{task.globalId || '-'}</div>
          </div>
          <div className={classes.infoBlock}>
            <div className={classes.title}>Срок выполн.</div>
            <div className={clsx(classes.time, endDate.className)}>
              {endDate.label}
            </div>
          </div>
          <div className={classes.infoBlock}>
            <div className={classes.title}>Длительность</div>
            <div className={classes.text}>{start.to(endDate, true)}</div>
          </div>
          <div className={classes.infoBlock}>
            <div className={classes.title}>Филиал</div>
            <div className={classes.text}>{task.subdivision}</div>
          </div>
          <div className={classes.infoBlock}>
            <div className={classes.title}>Описание</div>
            <div className={classes.text}>{task.description}</div>
          </div>
        </div>
        {commentsRSE && (
          <AccordionTwoHead heading={'Потребности клиента'}>
            <div className={classes.needs}>
              <ClientNeeds isDisabled commentsRSE={commentsRSE} />
            </div>
          </AccordionTwoHead>
        )}
        <AccordionTwoHead heading={'История подбора'}>
          <HistoryOfSelection
            id={task.dealId}
            tradeInCarVin={sale?.tradeInCarVin}
          />{' '}
        </AccordionTwoHead>
        <AccordionTwoHead heading={'Коментарии'}>
          <Grid item xs={12} md={12}>
            {comments?.map(
              (comment, index) =>
                !!comment.text && (
                  <CommentItem
                    comment={comment}
                    key={`comment_${index}`}
                    isLast={comments?.length === index}
                  />
                )
            )}
          </Grid>
        </AccordionTwoHead>
      </div>
      {!task?.completedDate && (
        <div className={classes.btns}>
          {task.type === CS_ISSUE_MANAGER && (
            <div className={classes.row}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={onCall}
              >
                Позвонить
              </Button>
              <Button
                variant="contained"
                fullWidth
                onClick={handleOpen('isCloseTaskOpen')}
              >
                Закрыть задачу
              </Button>
            </div>
          )}
          {task.type !== CS_ISSUE && task.type !== CS_ISSUE_MANAGER && (
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={task.type === CS_CALL_CLIENT ? onCall : goToSelection}
            >
              {task.type === CS_CALL_CLIENT ? 'Позвонить' : 'Продолжить подбор'}
            </Button>
          )}
          {[CS_CALL_CLIENT, CS_MEET_CLIENT, CS_ISSUANCE_CAR].includes(
            task.type
          ) && (
            <div className={classes.row}>
              <Button
                variant="contained"
                color={'secondary'}
                fullWidth
                onClick={handleOpen('isCloseRlModalOpen')}
              >
                В упущен
              </Button>
              <Button
                variant="contained"
                fullWidth
                onClick={handleOpen('isCloseTaskOpen')}
              >
                Закрыть задачу
              </Button>
            </div>
          )}
        </div>
      )}

      <Modal open={open.isCloseTaskOpen} fullWidth>
        <CloseTaskComponent
          onClose={handleOpen('isCloseTaskOpen')}
          taskType={task.type}
          onSave={onSaveCloseTask}
          taskId={task?.id}
        />
      </Modal>

      <Modal open={open.isCreateTask} fullWidth>
        <CreateTaskComponent
          saleId={task?.dealId}
          globalId={task?.globalId}
          isPayment={sale?.saleStatus?.code === PAYMENT}
          client={{
            contactFullname: task.contactFullname,
            phoneNumber: task.contactPhone1 || '',
            additionalPhoneNumber: task.contactPhone2 || ''
          }}
          onClose={handleOpen('isCreateTask')}
          onSuccess={onSaveNewTask}
        />
      </Modal>

      <Modal open={open.isCloseRlModalOpen} fullWidth>
        <CloseRLModal
          onClose={handleOpen('isCloseRlModalOpen')}
          onSave={onReasonClose}
        />
      </Modal>
    </PageContainerMobile>
  )
}

export default TaskModal
